import { render } from "./OapMikMakCoupon.vue?vue&type=template&id=044d88c7"
import script from "./OapMikMakCoupon.vue?vue&type=script&lang=js"
export * from "./OapMikMakCoupon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__